import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";

/**
 * What this delete will and will not break, stated inside the confirm.
 *
 * Deleting is a full delete — provider copies, every stored object, the
 * rows — and Studio changes what that can mean: a published edit made from
 * this video is self-contained and keeps playing, but a *draft* using it
 * genuinely loses footage. Saying so at the moment of deletion is the
 * difference between an informed delete and a surprise a week later.
 */
export function DeleteImpact({ recordingId }: { recordingId: string }) {
  const { t } = useTranslation("library");
  const references = useQuery({
    queryKey: ["references", recordingId],
    queryFn: () => api.getRecordingReferences(recordingId),
    staleTime: 30_000,
  });

  const { edits = 0, drafts = 0 } = references.data ?? {};
  if (references.isLoading || (edits === 0 && drafts === 0)) return null;

  return (
    <div className="mt-2 space-y-1 text-[12px] leading-relaxed">
      {drafts > 0 ? (
        <p className="text-warning">
          {t("deleteImpact.drafts", { count: drafts })}
        </p>
      ) : null}
      {edits > 0 ? (
        <p className="text-text-muted">
          {t("deleteImpact.edits", { count: edits })}
        </p>
      ) : null}
    </div>
  );
}
